/**
 * What a content item plays, for labels in the dashboard.
 *
 * The runtime keeps `type` to `live | vod` and stores a Castr playlist as
 * `type: 'vod'` + `castr_ref.type: 'playlist'`, so the kind is derived from the
 * Castr ref when there is one and falls back to `type`.
 */

/** @returns {'live'|'playlist'|'vod'} */
export function contentKind(item) {
	const ref = item?.castr_ref?.type
	if (ref === 'playlist') return 'playlist'
	if (ref === 'live' || item?.type === 'live') return 'live'
	return 'vod'
}

export const KIND_LABELS = Object.freeze({ live: 'Live', playlist: 'Playlist', vod: 'VOD' })

/** Short label for type columns and badges: "Live", "Playlist" or "VOD". */
export function contentKindLabel(item) {
	return KIND_LABELS[contentKind(item)]
}

/** Noun for prose about a Castr-linked item: "live stream", "playlist", "video". */
export function castrSourceNoun(ref) {
	if (ref?.type === 'playlist') return 'playlist'
	if (ref?.type === 'live') return 'live stream'
	return 'video'
}

/** Filter options for the Library toolbar; '' = every kind. */
export const KIND_FILTER_OPTIONS = Object.freeze([
	{ value: '', text: 'All types' },
	{ value: 'live', text: 'Live' },
	{ value: 'vod', text: 'VOD' },
	{ value: 'playlist', text: 'Playlist' },
])
